export var isPrimitiveArrayOptions = function (options) {
    return Array.isArray(options);
};
export var isStringArrayOptions = function (options) {
    return options.length === 0 || typeof options[0] === 'string';
};
export var isStringOption = function (option) {
    return typeof option === 'string';
};
export var isPrimitiveValue = function (value) {
    return typeof value == 'boolean' ||
        typeof value == 'number' ||
        typeof value == 'string';
};
export var isPrimitiveArrayValue = function (value) {
    return Array.isArray(value);
};
export var isMapOfValuesByFieldName = function (value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};
